import { useCallback, useEffect, useState } from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { phoneFormationBack } from '@app/helpers/phoneFormation';
import { Button } from '@ui-kit/Button';
import { CheckBoxAgree } from '@ui-kit/CheckBox';
import { yupResolver } from '@hookform/resolvers/yup';
import { schemaFormRecordPhone } from '@helpers/validationForm';
import { ServiceNotification } from '@services/ServiceNotification';
import { FormField } from '@app/shared';

import styles from './FormRecordPhone.module.scss';
import { ServiceEcommerce2 } from '@app/services/ServiceEcommerce';

type Inputs = {
  name: string;
  phone: string;
  agree: boolean;
};

export const FormRecordPhone = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [status, setStatus] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm<Inputs>({
    resolver: yupResolver(schemaFormRecordPhone),
  });

  const onSubmit: SubmitHandler<Inputs> = useCallback(
    async data => {
      if (!executeRecaptcha) {
        console.log('Execute recaptcha not yet available');
        return;
      }

      const token = await executeRecaptcha('submit');
      data.phone = phoneFormationBack(data.phone);

      ServiceEcommerce2.form('FormRecordPhone');

      ServiceNotification.postFeedbackRequest({ ...data, captchaTokenGoogle: token }).then(() => {
        setStatus(true);
        setValue('name', '');
        setValue('phone', '');
        setTimeout(() => {
          setStatus(false);
        }, 3000);
      });
    },
    [executeRecaptcha],
  );

  useEffect(() => {
    setDisable(!watch('agree'));
  }, [watch('agree')]);

  return (
    <form autoComplete="off" className={styles.Container} onSubmit={handleSubmit(onSubmit)}>
      <p className={styles.Title}>Заказать обратный звонок:</p>
      <div className={styles.BoxInput}>
        <FormField
          label="Имя"
          name={'name'}
          type={'text'}
          register={register}
          value=""
          setValue={setValue}
          error={errors?.name?.message}
          dataTestId="formrecordphone-name"
          isRequired
        />
        <FormField
          autoComplete="off"
          label="Телефон"
          name={'phone'}
          type={'tel'}
          register={register}
          placeholder={'+7 (___) ___-__-__'}
          value=""
          setValue={setValue}
          error={errors?.phone?.message}
          dataTestId="formrecordphone-phone"
        />
      </div>
      <CheckBoxAgree className={styles.Checkbox} defaultChecked={true} id={'agree'} reg={register('agree')} />
      <Button themes={status ? 'success' : 'red'} disabled={disable} fullWith data-testid="formrecordphone-btn-order">
        Заказать звонок
      </Button>
    </form>
  );
};
